import React, { ReactElement } from 'react';

import {
  ChoicePropType,
  ChoiceOptionType,
  QuestionResponseType,
} from '@/modules/types/choice';
import SingleChoice from './SingleChoice';
import MultiChoice from './MultiChoice';
import Sort from './Sort';
import TrafficLight from './TrafficLight';
import DragDrop from './DragDrop';
import './Choice.scss';
import TrueFalse from './TrueFalse';

const getChoiceComponentByType = (
  type: number,
  choices: ChoiceOptionType[],
  handler: (answer: string) => void,
  isDisabled: boolean,
) => {
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  switch (type) {
    case QuestionResponseType.singleAnswer:
      return (
        <SingleChoice
          choices={choices}
          isDisabled={isDisabled}
          handler={handler}
        />
      );
    case QuestionResponseType.multiCorrect:
      return (
        <MultiChoice
          choices={choices}
          isDisabled={isDisabled}
          handler={handler}
        />
      );
    case QuestionResponseType.trueOrFalse:
      return <TrueFalse isDisabled={isDisabled} handler={handler} />;
    case QuestionResponseType.match:
      return <DragDrop choices={choices} handler={handler} />;
    case QuestionResponseType.order:
      return <Sort choices={choices} handler={handler} />;
    case QuestionResponseType.trafficLight:
      return (
        <TrafficLight
          choices={choices}
          isDisabled={isDisabled}
          handler={handler}
        />
      );
    default:
      return <div />;
  }
};

const Choice = ({
  questionType,
  choiceList,
  handler,
  isDisabled,
}: ChoicePropType): ReactElement => (
  <div id="Choice">
    {getChoiceComponentByType(questionType, choiceList, handler, isDisabled)}
  </div>
);

export default Choice;
